import React from "react";
import "./PageHero.css";
import Reveal from "../reveal/Reveal";

export default function PageHero({ kicker, title, description, children }) {
  return (
    <section className="page-hero">
      <div className="page-hero-glow" aria-hidden="true" />
      <Reveal>
        <div className="page-hero-inner">
          {kicker && <span className="section-kicker">{kicker}</span>}
          <h1 className="page-hero-title">{title}</h1>
          {description && <p className="page-hero-desc">{description}</p>}
          {children && <div className="page-hero-extra">{children}</div>}
        </div>
      </Reveal>
    </section>
  );
}
